export const ANONYMOUS_ID_COOKIE_NAME = 'ajs_anonymous_id';
export const BOT_SCORE_COOKIE_NAME = 'X-NW-sig_lvl';
export const HAS_WP_NONCE_HEADER = 'x-has-wp-nonce';
export const IS_BOT_COOKIE_NAME = 'X-NW-bt';
export const IS_VERIFIED_BOT_COOKIE_NAME = 'X-NW-f_opt';
export const IS_PREVIEW_MODE_HEADER = 'x-is-preview-mode';
export const PREVIEW_MODE_QUERY_PARAM = 'previewMode';
export const WORDPRESS_ACTIVE_SESSION_COOKIE = 'wordpress_session_active';
export const WORDPRESS_ACTIVE_SESSION_PREFIX = 'wordpress_logged_in_';
export const WP_NONCE_QUERY_PARAM = '_wpnonce';
export const VARIANT_DECISION_HEADER = 'x-experiment-variant';
